const normalizeSidebarOrganizationSnapshot = ({ snapshot, companyId } = {}) => {
  return {
    sidebarType: snapshot?.sidebarType || 'home',
    groups: Array.isArray(snapshot?.groups) ? snapshot.groups : [],
    folders: Array.isArray(snapshot?.folders) ? snapshot.folders : [],
    placements: Array.isArray(snapshot?.placements) ? snapshot.placements : [],
    scopeCompanyId: companyId || null,
    loaded: true
  };
};

export default normalizeSidebarOrganizationSnapshot;
